<template>
  <div class="Marketing" :style="marketingStyle">
      <div v-for="(item, index) in detailData.list" :key="index" :class="itemClass(item)">
          <div class="box">
            <p class="title">{{ item.title }}</p>
            <p class="text">{{ item.text }}</p>
          </div>
      </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'Marketing',
  props: {},
  components: {},
  mixins: [mixins],
  data() {
    return {
      detailData: {
        list: []
      },
      pattern: {}
    }
  },
  watch: {
  },
  computed: {
    marketingStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
      }
    },
  },
  methods: {
    itemClass(item){
      let classStr = ""
      if(this.pattern.type == 1){
        classStr += "one"
      }else if(this.pattern.type == 2){
        classStr += "two"
      }
      if(item.type == 1){
        classStr += " memberPoints"
      }else if(item.type == 2){
        classStr += " getMoney"
      }else if(item.type == 3){
        classStr += " votingActivity"
      }
      return classStr
    },
    async init() {
      this.detailData = await this._filter(this.itemData)
      this.pattern = this.detailData.pattern || {}
      console.log("Marketing----------this.detailData");
      console.log(this.detailData);
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.Marketing{
  display: flex;
  justify-content: space-between;
  height: 90px;
  .box {
    position: absolute;
    top: 5px;
    left: 75px;
    bottom: 5px;
    right: 5px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    padding-bottom: 0px;
    .text {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      max-width: calc(100% - 5px);
    }
    .title{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .title{
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    // position: absolute;
    // top: 24px;
    // left: 75px;
    // max-width: calc(100% - 5px);
    // overflow: hidden;
    // white-space: nowrap;
    
  }
  .text{
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    opacity: 0.5;
    // position: absolute;
    // top: 48px;
    // left: 75px;
    // max-width: calc(100% - 5px);
    // overflow: hidden;
    // white-space: nowrap;
    padding-right: 5px;
    // text-overflow: ellipsis;
  }
  .one{
    width: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    &.memberPoints{
      background-image: url("../image/memberPoints.png");
    }
    &.getMoney{
      background-image: url("../image/getMoney.png");
    }
    &.votingActivity{
      background-image: url("../image/votingActivity.png");
    }
  }
  .two{
    width: calc(50% - 5px);
    background-size: 100% 100%;
    position: relative;
    &.memberPoints{
      background-image: url("../image/memberPoints_D.png");
    }
    &.getMoney{
      background-image: url("../image/getMoney_D.png");
    }
    &.votingActivity{
      background-image: url("../image/votingActivity_D.png");
    }
  }
}
</style>
